module.exports = __webpack_public_path__ + "static/media/help-bg.3a6c25f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Help/help-bg.svg
// module id = 405
// module chunks = 0